<template>
    <div class="appointmentList-view">
        <div>
            <el-input class="w200 mb10 mr10" placeholder="请输入托盘名称" v-model="serchParams.stackName" clearable />
            <el-input class="w200 mb10 mr10" placeholder="请输入托盘标识" v-model="serchParams.stackHandle" clearable />
            <el-button type="primary" class="myBtn" @click="serchquery">搜索</el-button>
            <el-button type="primary" class="myBtn" @click="reset">重置</el-button>
            <el-button type="primary" @click="printAll">批量打印</el-button>
        </div>
        <commonTable :tableData="tableData" @handleSizeChange="handleSizeChange"
            @handleCurrentChange="handleCurrentChange" :currentPage="queryParam.pageNum" :loading="loading"
            :total="total">
            <template v-slot:table>
                <el-table-column prop="stackName" align="center" label="托盘名称" />
                <el-table-column prop="stackHandle" align="center" label="托盘标识" />
                <el-table-column prop="img" align="center" label="托盘二维码">
                    <template slot-scope="scope">
                        <div :id="`codeImage${scope.row.id}`">
                            <!-- 修改 :text 绑定为 scope.row.stackHandle -->
                            <vue-qr :size="80" :margin="10" :auto-color="true" :dot-scale="1"
                                :text="scope.row.stackHandle" />
                            <div style="font-size: 12px;font-weight: bold">{{scope.row.stackName}}</div>
                        </div>
                    </template>
                </el-table-column>

                <el-table-column prop="storeNum" align="center" label="容器数量">
                    <template slot-scope="scope">
                        <el-button type="text" @click="codeDetail(scope.row,0)">{{scope.row.storeNum||'0'}}</el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="createBy" align="center" label="创建人" />
                <el-table-column prop="createTime" align="center" label="创建时间" />
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <!-- <el-button type="text" @click="unitEdit(scope.row)">编辑</el-button> -->
                        <el-button type="text" @click="delUnit(scope.row)">删除</el-button>
                        <el-button type="text" @click="downTwo(scope.row)">下载二维码</el-button>
                        <el-button type="text" @click="printBtn(scope.row)">打印</el-button>
                        <!-- 导出托盘码 -->
                        <el-button type="text" @click="exportCode(scope.row)">导出托盘码</el-button>
                    </template>
                </el-table-column>
            </template>
        </commonTable>
        <store-code ref="code"></store-code>

        <code-print-stack ref="CodePrintStack"></code-print-stack>
    </div>
</template>

<script>
    import commonTable from "@/components/common/commonTable.vue";
    import service, { get, post, put, deletes } from "@/utils/request";

    import commTable from "@/mixins/commTable";
    import { fetchChangeBoss, getWxCodeImg, queryPageEmployee, updateEmployee } from "@/api/companyManage";
    import { exportStack } from "@/api/stack";
    import utils from "@/utils";
    import { mapGetters } from "vuex";
    import { checkPermission } from "@/directives/permission";
    import StoreCode from "./component/storeCode.vue";
    import CodePrintStack from "./component/codePrint_stack.vue";
    import html2canvas from "html2canvas";
    import VueQr from "vue-qr";
    import { codeUrl } from '@/utils/constant'
    import { baseUrl } from "@/utils/index";
    export default {
        name: "user",
        mixins: [commTable],
        components: { CodePrintStack, StoreCode, commonTable, VueQr },
        data() {
            return {
                queryParam: {
                    pageNum: 1
                },
                serchParams: { stackName: '' },
                addDialogShow: false,
                formData: {
                    stackName: '',
                },
                tableData: [],
                rules: {
                },
                roleList: [],
                departmentList: [],
                changeDialogVisible: false,
                allTableData: [],
                newUserId: null,
                userInfo: this.$store.state.loginRoot.userInfo,
                codeUrl: codeUrl,
                parentItem: '',
            };
        },
        mounted() {
            this.initList('/stack', this.serchParams);
        },
        methods: {
            checkPermission,
            reset() {
                this.serchParams.stackName = ''
                this.serchParams.stackHandle = ''
                this.queryParam.pageNum = 1
                this.serchquery()
            },
            serchquery() {
                this.queryParam.pageNum = 1
                this.initList('/stack', this.serchParams);
            },
            unitEdit(row) {
                this.formData = {
                    id: row.id,
                    name: row.name,
                    symbol: row.symbol
                }
                this.title = "编辑单位"
                this.addDialogShow = true
            },
            delUnit(row) {
                let params = {
                    id: row.id
                }
                // 使用 $confirm 弹窗提示用户确认删除操作
                this.$confirm('确定要删除该托盘吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    console.log('row', params)
                    get('/stack/delete', params).then(res => {
                        this.$message({
                            message: "操作成功",
                            type: "success",
                        });
                        this.initList('/stack', this.serchParams);
                    })
                }).catch(() => {
                    // 用户取消操作，给出提示
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },

            codeDetail(row, flag) {
                this.$refs.code.openDialog(row, flag)
            },
            downTwo(row) {
                console.log(row.img);
                let dom = document.getElementById('codeImage' + row.id);
                html2canvas(dom, { scale: 4 }).then(canvas => {
                    let dataURL = canvas.toDataURL("image/png");
                    if (dataURL !== "") {
                        let a = document.createElement('a')
                        a.download = row.stackName + '.png';
                        a.href = dataURL;
                        a.click()
                    }
                })
            },
            printBtn(data) {
                this.$refs.CodePrintStack.visiblePrint = true
                this.$refs.CodePrintStack.init('', data.id)
            },
            printAll() {
                this.$refs.CodePrintStack.visiblePrint = true
                this.$refs.CodePrintStack.init(this.parentItem.id, '')
            },
            exportCode(row) {
                console.log(row);
                // 检查容器数量是否为 0
                if (row.storeNum === 0 || row.storeNum === '0') {
                    this.$message({
                        type: "warning",
                        message: "容器数量为 0，无法导出",
                    });
                    return;
                }
                let params = {
                    id: row.id,
                }
                exportStack(params).then(res => {
                    if (res.code !== 200) {
                        // 检查是否导出失败
                        this.$message({
                            type: "error",
                            message: "导出失败",
                        });
                        return;
                    }
                    console.log(baseUrl);
                    let urls = baseUrl + res.data;
                    const link = document.createElement("a");
                    link.href = urls;
                    link.style.display = "none";
                    link.download = "托盘码.xlsx"; // 设置下载的文件名
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    this.$message({
                        type: "success",
                        message: "导出成功",
                    });
                }
                )
            },

        }
    };
</script>

<style lang="scss" scoped>
    .appointmentList-view {
        background: #ffffff;
        padding: 24px;
    }

    .head-img {
        width: 30px;
    }

    .nickname {
        line-height: 30px;
        vertical-align: top;
        margin-left: 4px;
    }
</style>